import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { PrimeNgModule } from '@app/shared/primeng/primeng.module';
import { TranslateModule } from '@ngx-translate/core';
import { ChatLayerService } from './chat-layer.service';

@Component({
    selector: 'app-chat-layer',
    standalone: true,
    imports: [CommonModule, TranslateModule, PrimeNgModule],
    templateUrl: './chat-layer.component.html',
    styleUrl: './chat-layer.component.scss',
})
export class ChatLayerComponent {
    @Input() state: 'Default' | 'Hover' | 'Expanded' = 'Hover';

    hellow = 'core.components.chatLayer.hellow';
    helpYou = 'core.components.chatLayer.helpYou';
    financingVehicle = 'core.components.chatLayer.financingVehicle';
    configurationVehicle = 'core.components.chatLayer.configurationVehicle';
    soapRequest: any;
    soapResponse: any;
    result!: string;
    error!: string;

    isOpenedChatLayer: Boolean = false;

    constructor(private chatLayerService: ChatLayerService) {}

    ngOnInit(): void {}

    onShowChatLayer(event: Event) {
        this.isOpenedChatLayer = true;
    }

    onHideChatLayer(event: Event) {
        this.isOpenedChatLayer = false;
    }

    onclickOpenChat() {

        this.chatLayerService.getChatLink().subscribe({
            next: (data: any) => {
              this.soapRequest = this.chatLayerService.getSoapRequestXML();
              this.soapResponse = data;
              this.result = this.extractDataFromXml(data);
            },
            error: (error: any) => {
                this.error = 'Error';
            }
        });

        window.open(this.result);
    }

    private extractDataFromXml(xmlData: string): string {
        let json : any =  this.chatLayerService.xmlToJson(xmlData);
        let result =  json["soap:Envelope"]["soap:Body"]["Response"]["Result"]["_text"];
        return result.url + result.token;
    }
}